"use client";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { CORE_COLORS, CORE_FONT } from "@/lib/theme/core";
import { AccountNavContent } from "./account-nav-content";

type AccountDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function AccountDrawer({ open, onOpenChange }: AccountDrawerProps) {
  const handleClose = () => onOpenChange(false);

  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-[80] bg-black/50"
        />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right fixed inset-y-0 right-0 z-[80] flex h-full w-full max-w-none flex-col bg-white shadow-xl ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 sm:max-w-[400px]"
          style={{
            fontFamily: CORE_FONT.sans,
            borderLeft: `1px solid ${CORE_COLORS.dividerSoft}`,
          }}
        >
          <DialogPrimitive.Title className="sr-only">
            會員選單
          </DialogPrimitive.Title>

          <div
            className="flex shrink-0 items-center justify-end px-[20px] pt-[20px] pb-[8px]"
          >
            <button
              type="button"
              onClick={handleClose}
              aria-label="關閉"
              className="inline-flex size-[36px] items-center justify-center rounded-full transition-colors duration-150 hover:bg-[#f5f5f7] active:scale-[0.95] motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[color:var(--focus-ring)]"
              style={
                {
                  ["--focus-ring" as string]: CORE_COLORS.brandGreen,
                } as React.CSSProperties
              }
            >
              <X
                className="size-[18px]"
                color={CORE_COLORS.textPrimary}
                strokeWidth={2}
              />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto px-[20px] pb-[32px]">
            <AccountNavContent onNavigate={handleClose} />
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
